document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 960) {
    // get all accordions (mobile)
    let accordionWrapper = document.querySelector('.drawer-menu__all-links');
    let accordions = accordionWrapper?.querySelectorAll('.accordion-item.level-1.collapsible');

    accordions?.forEach((accordion, index) => {
      // add event listener here
      let accordionHeader = accordion.querySelector('.accordion-header');
      let accordionBody = accordion.querySelector('.accordion-body');

      // toggle accordion body display
      accordionHeader.addEventListener('click', () => {
        accordion.classList.toggle('show-body');
      });

      // handle nested accordions
      let subAccordions = accordionBody.querySelectorAll('.accordion-item.level-2.collapsible');
      // if submenus exists
      if (subAccordions.length > 0) {
        subAccordions.forEach((subAccordion, index) => {
          // add event listener here
          let subAccordionHeader = subAccordion.querySelector('.accordion-header');
          let subAccordionBody = subAccordion.querySelector('.accordion-body');

          // toggle accordion body display
          subAccordionHeader.addEventListener('click', () => {
            subAccordion.classList.toggle('show-body');
          });
        });
      }
    });
  }
});
